export {PushTANAuthenticatorModule} from '../src/PushTANAuthenticator/PushTANAuthenticatorModule';
export {IPushTANAuthenticator} from '../src/PushTANAuthenticator/IPushTANAuthenticator';